<script setup>
defineOptions({ name: "ViewHome" });

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

import { NIcon } from "naive-ui";
import Areas from "../components/Areas.vue";
import Section from "../components/Section.vue";
import Logo from "../components/Logo.vue";
import area_1_src from "../assets/1.png";
import area_2_src from "../assets/2.png";
import area_3_src from "../assets/3.png";
import area_4_src from "../assets/4.png";
import area_5_src from "../assets/5.png";
import area_6_src from "../assets/6.png";
import { IconDown } from "../components/icons";
import { ROUTE_AFFORDABLE_HOUSING, ROUTE_IMPACT_LITIGATION } from "../routing";

import colors from "../colors.js";
import texts from "../texts.json";
import LogoType from "../components/LogoType.vue";
</script>

<template>
  <!-- <Loader type="bounce" /> -->
  <Section
    class="section_gradient"
    gap="2rem"
    data-scroll
    data-scroll-css-progress
  >
    <Logo style="width: 12rem; margin-bottom: 0.5rem" />
    <LogoType class="text-size-large color-brand_light" />
    <div class="text-caps text-sparse-3 text-lighter">
      Practice with purpose
      <!--  -->
    </div>
    <div class="text-size-small text-lighter text-sparse-1">
      {{
        `${
          new Date().getFullYear() - 2008
        } Years of Impact.  $5 Billion in Affordable Housing Transactions.`
      }}
    </div>
    <template #footer>
      <a
        href="#about"
        class="text-caps align-center"
        :style="{ opacity: 'calc(1 - 2 * var(--progress))' }"
      >
        <NIcon size="64" depth="3"><IconDown /></NIcon>
      </a>
    </template>
  </Section>

  <Section
    data-scroll
    data-scroll-css-progress
    id="about"
    :background="colors.accent_light"
    padding="4rem 0 0"
  >
    <div
      :style="{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem',
      }"
    >
      <div
        :key="it"
        v-for="it in [
          'Deal makers.',
          'Problem solvers.',
          'Strategic + Dynamic Counsel.',
        ]"
        class="text-size-large text-sparse-1 text-line-normal text-caps color-brand_light width-50rem"
      >
        {{ it }}
      </div>
      <div></div>
      <!--
      <div class="text-size-large text-line-normal text-caps width-50rem">
        {{ texts.brand_name_long }}
      </div>
      -->
      <div
        class="text-line-relaxed width-50rem"
        :style="{ marginTop: '-1.5rem' }"
      >
        <b>{{ texts.brand_name_long }}</b> is an “AV Preeminent” rated law firm
        with an unwavering commitment to its clients and community, and is among
        California’s most unique and respected boutique law firms. The principal
        partners are big law firm veterans and former in-house lawyers for
        national companies. HB+D provides the highest level of legal services in
        the areas of affordable housing, community development, real estate and
        related litigation without the unnecessary formality and expense of
        traditional firms.
      </div>
      <div></div>
      <div style="margin: auto calc(var(--page-padding) * -1)">
        <Areas
          :items="[
            {
              label: 'Affordable Housing',
              description:
                'Advising developers and investors on complex affordable housing and community development projects, structuring debt, equity, and tax credit financing with deep expertise in public finance and tax law.',
              route: { name: ROUTE_AFFORDABLE_HOUSING },
              image: area_1_src,
            },
            {
              label: 'Impact Litigation',
              description:
                'Delivering elite, multidisciplinary litigation services for complex commercial disputes, combining trial excellence with strategic, results-driven representation.',
              route: { name: ROUTE_IMPACT_LITIGATION },
              image: area_2_src,
            },
          ]"
          :imageItems="
            shuffle([
              area_1_src,
              area_2_src,
              area_3_src,
              area_4_src,
              area_5_src,
              area_6_src,
            ])
          "
        />
      </div>
    </div>
  </Section>
</template>
